export default __webpack_public_path__ + "static/media/T5WInfographics1.ce521c66754792a612144fb3ace6a29f.png";